/* eslint-disable sort-keys */

const menuData = () => ({
  categories: [
    {
      name: "Necklaces",
      type: "direct-link",
      device: "all",
      images: [],
      link: "/",
    },
    {
      name: "About Us",
      type: "direct-link",
      device: "all",
      images: [],
      link: "/about-us",
    },
    // {
    //   name: "Terms and Conditions",
    //   type: "direct-link",
    //   device: "all",
    //   images: [],
    //   link: "/terms-conditions",
    // },
    {
      name: "Register",
      type: "external-link",
      device: "all",
      images: [],
      link:
        "https://docs.google.com/forms/d/e/1FAIpQLSddHc9e5XkG5rwQI_-3FzFrGitawdEIR_-wteySrUXQ9uxfpw/viewform",
    },
    {
      name: "Contact Us",
      type: "external-link",
      device: "all",
      images: [],
      link: "mailto:wholesale@safyrelabs.com",
    },
  ],
})

export default menuData
